module.exports = __webpack_public_path__ + "static/festival6.199c3b74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/festival6.jpg
// module id = 620
// module chunks = 262155479546674